<script lang="ts">
	import type { CashReceiptResponse, OrderData, PaymentData } from "@hitit/api";
	//UI
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	//Utils
	import { t, api } from "@hitit/hub/src/stores";
	import { DefaultDone } from "@hitit/new_ui";
	import { addSpacer } from "@hitit/hub/src/functions/utils/phone";
	import { createEventDispatcher } from "svelte";

	export let rewardData = "";
	export let pointEarnedModalCloseHandler: () => void;
	export let orderData: OrderData;

	const dispatch = createEventDispatcher();

	let earnedSend = false;
	let phoneNumber = "";
	let phoneNumberError = false;

	function inputChangeHandler(e: Event) {
		const target = e.currentTarget as HTMLInputElement;
		const { value } = target;
		const replace = value
			.replace(/-/g, "") //"-"제거
			.replace(/[^0-9]/g, ""); //숫자를제거한 나머지 모두 제거
		const newValue = addSpacer(replace);
		target.value = newValue;
		phoneNumber = replace;
	}

	function updateOrder(orderDTO: OrderData) {
		dispatch("EARNED_UPDATE_ORDER", orderDTO);
	}

	async function pointRewardHandler() {
		try {
			if (phoneNumber.length === 0) {
				phoneNumberError = true;
				return;
			}
			const postRewardDTO = {
				orderId: orderData.id!,
				phonenumber: phoneNumber,
				phonenumberCountryCode: "82",
			};
			await $api.postPointReward(orderData.storeid || "", postRewardDTO);
			const r = await $api.getOrder(orderData.storeid!, orderData.id!);
			earnedSend = true;
			updateOrder(r.data.orderDTO);
		} catch (e) {
			console.log(e);
		}
	}
	$: phoneNumberError = phoneNumber.length > 0 && phoneNumber.length < 11;
</script>

<div class="modal-background" t-id="PointEarnedModal">
	{#if earnedSend}
		<div class="step-two modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={pointEarnedModalCloseHandler}
			/>
			<span class="title"
				>{`${rewardData} ${$t("hub.order.point.point_accumulated")}`}</span
			>
			<div class="animation-box">
				<DefaultDone color={"#000000"} circleBackground={"#e5e6ec"} />
			</div>
			<div class="contents-box">
				<span class="phone-number">{$t("global.point.accumulatedPoint")}</span>
				<span class="box-content">1,500P</span>
			</div>
			<div class="issuance-btn btn" on:click={pointEarnedModalCloseHandler}>
				<span>{$t("global.ok")}</span>
			</div>
		</div>
	{:else}
		<div class="step-one modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={pointEarnedModalCloseHandler}
			/>
			<span class="title"
				>{`${rewardData} ${$t("hub.order.point.point_accumulation")}`}</span
			>

			<span class="phone-number">{$t("hub.store.storeinfo.phonenumber")}</span>
			<div class="input-box">
				<input
					bind:value={phoneNumber}
					on:input={inputChangeHandler}
					maxlength="13"
				/>
				<img src={closeBtn} on:click={() => (phoneNumber = "")} alt="close" />
			</div>
			{#if phoneNumberError}
				<span class="input-error"
					>{$t("hub.order.incorrectly_formatted_phone_number")}</span
				>
			{/if}
			<div class="send-btn btn" on:click={pointRewardHandler}>
				<span>적립</span>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 10;
	}

	.modal {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background-color: white;
		border-radius: 5px;

		.modal-close {
			position: absolute;
			top: -40px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}
	.step-one {
		width: 320px;
		height: fit-content;
		max-height: 285px;
		padding: 20px 10px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 500;
			color: #46474b;
			margin-bottom: 30px;
		}

		.input-box {
			display: flex;
			align-items: center;
			width: 300px;
			height: 32px;
			background-color: #f0f0f4;
			border-radius: 5px;
			margin-top: 10px;
			padding-right: 20px;
			input {
				all: unset;
				width: 100%;
				@include appleAdjustTextForSize(16);
				color: #46474b;
				padding: 0px 10px;
			}
			img {
				width: 15px;
				height: 15px;
				cursor: pointer;
			}
		}
		.input-error {
			@include appleAdjustTextForSize(14);
			color: red;
			margin-right: auto;
		}
	}
	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 32px;
		min-height: 32px;
		border-radius: 5px;
		background-color: #6591fa;
		margin-top: 20px;
		cursor: pointer;

		span {
			color: white;
		}
	}

	.contents-box {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 10px;
		width: 100%;
	}

	.phone-number {
		@include appleAdjustTextForSize(16);
		color: #6d6f76;
		margin-right: auto;
	}

	.step-two {
		width: 320px;
		height: 280px;
		padding: 20px 10px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 500;
			color: #46474b;
			margin-bottom: 30px;
		}

		.animation-box {
			width: 83px;
			height: 79px;
			margin-bottom: 20px;
		}

		.box-title {
			@include appleAdjustTextForSize(16);
			color: #6d6f76;
		}
		.box-content {
			@include appleAdjustTextForSize(16);
			font-weight: 400;
			color: #46474b;
		}
	}
	@include DesktopSize {
		.modal {
			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}
		}
		.step-one {
			width: 340px;
			padding: 30px;

			.title {
				@include appleAdjustTextForSize(16, false);
			}

			.input-box {
				width: 330px;
				height: 40px;
				padding-right: 10px;
				input {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.input-error {
				@include appleAdjustTextForSize(14, false);
			}
		}
		.btn {
			height: 40px;
			min-height: 40px;
		}

		.phone-number {
			@include appleAdjustTextForSize(16, false);
		}

		.step-two {
			width: 350px;
			padding: 30px;

			.title {
				@include appleAdjustTextForSize(16, false);
			}

			.box-title {
				@include appleAdjustTextForSize(16, false);
			}
			.box-content {
				@include appleAdjustTextForSize(16, false);
			}
		}
	}
</style>
